import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoaderComponent } from './loader/loader.component';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { MediaMatcher } from '@angular/cdk/layout';
import { User } from './_model/user';
import { Router } from '@angular/router';
import { AuthenticationService } from './_services/authentication.service';
import { setTheme } from 'ngx-bootstrap/utils';
import { DataService } from './_services/data.service';
import { ToastrService } from 'ngx-toastr';

interface MenuItem {
  label: string;
  route: string;
  icon: string;
  roles: string[];
}

interface MenuGroup {
  label: string;
  icon: string;
  expanded: boolean;
  items: MenuItem[];
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FontAwesomeModule,
    NgxSpinnerModule,
    LoaderComponent
  ]
})
export class AppComponent implements OnDestroy, OnInit {

  mobileQuery: MediaQueryList;
  faUser = faUser;
  currentUser: User;
  sidenavStyle: string;
  sideNavContentStyle: any;
  opened: boolean;
  HEADER: string;

  private mobileQueryListener: () => void;

  //network status variables
  ping;
  updateAvailable = false;

  menuGroups: MenuGroup[] = [
    {
      label: 'İnsan Kaynakları',
      icon: 'group',
      expanded: false,
      items: [
        { label: 'Çalışanlar', route: 'employee1', icon: 'people', roles: ['ROLE_ADMIN', 'HR'] },
        { label: 'Portal Kullanıcıları', route: 'portaluser', icon: 'account_circle', roles: ['ROLE_ADMIN'] }
      ]
    },
    {
      label: 'Personel İşlemleri',
      icon: 'assignment_ind',
      expanded: false,
      items: [
        { label: 'İzin / Rapor', route: 'absence', icon: 'event_available', roles: [] },
        { label: 'Mesailer', route: 'overtime', icon: 'schedule', roles: [] },
        { label: 'Olay Tespit / Disiplin', route: 'request', icon: 'report_problem', roles: [] }
      ]
    },
    {
      label: 'Satınalma',
      icon: 'shopping_cart',
      expanded: false,
      items: [
        { label: 'Talep/Masraf', route: 'procurement', icon: 'receipt', roles: [] }
      ]
    },
    {
      label: 'Kalite ve İSG',
      icon: 'verified_user',
      expanded: false,
      items: [
        { label: 'EYS Dokümanları', route: 'generaldocument', icon: 'folder_open', roles: [] }
      ]
    },
    {
      label: 'Sistem',
      icon: 'settings',
      expanded: false,
      items: [
        { label: 'Parametre ve Alanlar', route: 'lookup', icon: 'tune', roles: ['ROLE_ADMIN'] },
        { label: 'Yetki Tanımları', route: 'item-authorizations', icon: 'security', roles: ['ROLE_ADMIN'] },
        { label: 'Aktarım İşlemleri', route: 'transfer', icon: 'sync', roles: ['ROLE_ADMIN'] }
      ]
    }
  ];

  constructor(changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    private authenticationService: AuthenticationService,
    private dataService: DataService,
    private toastr: ToastrService) {

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    setTheme('bs4');
    this.HEADER = '';
    router.events.subscribe((url: any) => {
      this.showSideNav(url.url);
    });

  }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => {
      this.currentUser = x;
    });
    //TODO DEVREYE ALINACAK this.checkNetworkParams();
  }

  isItemVisible(item: MenuItem): boolean {
    if (!this.currentUser) return false;
    if (!item.roles || item.roles.length === 0) return true;
    const isAdmin = this.currentUser?.selectedRole?.name === 'ROLE_ADMIN';
    const isHR = this.currentUser?.department?.name === 'HR';
    if (item.roles.includes('ROLE_ADMIN') && isAdmin) return true;
    if (item.roles.includes('HR') && (isHR || isAdmin)) return true;
    return false;
  }

  isGroupVisible(group: MenuGroup): boolean {
    return group.items.some(item => this.isItemVisible(item));
  }

  navigateTo(item: MenuItem): void {
    this.HEADER = item.label;
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([item.route]);
      });
  }

  changepage(page) {
    this.HEADER = page;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this.mobileQueryListener);
  }

  logout() {
    this.clearSideNav();
    this.authenticationService.logout();
    this.dataService.clear();
    this.router.navigate(['login']);
  }


  /**
   * logout sirasinda solda bulunan menu kismini css kullanarak yok etmemiz gerekiyor.
   * cunku <router-outlet></router-outlet> bolumu sidenav ile ic ice oldugu icin
   * ayiramiyoruz. Biz de bunun icin css ile yok etme yolunu sectik
   */
  clearSideNav() {
    this.opened = false;
  }

  showSideNav(url) {
    if (url !== '/login' && url !== '/roleselect') {
      this.opened = true;
    }
  }

  goProfilePage() {
    this.router.navigate(['profile']);
  }
  reloadPage() { window.location.reload(); }
}
